import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Slider, Typography } from '@material-ui/core';

//One again, taken directly from the Materiul-UI examples, and modified to fit our needs
const useStyles = makeStyles(theme => ({
  root: {
    width: 200,
    margin: theme.spacing(0.5, 3)
  },
}));

function valuetext(value) {
  return `${value}`;
}

export default function RangeSlider(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState([props.min, props.max]);

  const handleChange = (event, newValue) => {
    props.onSliderChange(newValue);
    setValue(newValue);
    //Send newValue to update function or something
  };

  return (
    <div className={classes.root}>
      <Typography variant='h6' align="center" id="range-slider" gutterBottom>
        YEAR
      </Typography>
      <Slider
        value={value}
        marks={true}
        step={1}
        min={props.min}
        max={props.max}
        onChange={handleChange}
        valueLabelDisplay={
          (value[0] === props.min && value[1] === props.max) ? "on" : "auto"
        }
        aria-labelledby="range-slider"
        getAriaValueText={valuetext}
      />
    </div>
  );
}